import { createSelector, createFeatureSelector } from '@ngrx/store';

import { ReportModuleState } from '../../models/report.model';

export const getReportModuleState = createFeatureSelector<ReportModuleState>('reportModule');

export const getTimeSeries = createSelector(getReportModuleState, (state) => state.timeSeries);

export const getNormalizedFlockData = createSelector(
  getReportModuleState,
  (state) => state.normalizedFlockDataObject,
);

export const getSelectedDataViewType = createSelector(
  getReportModuleState,
  (state) => state.selectedDataViewType,
);

export const getSelectedReport = createSelector(
  getReportModuleState,
  (state) => state.selectedReport,
);
